import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSpace from 'eco-design/base/eco-space';
import useCardsShowHook from '../useHooks/useCardsShowHook';

const F_IMAGE_MAP: Record<string, { pc: string; pad: string; h5: string }> = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1768186914591/full-width-carousel%20(1).jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1768186913469/Frame%202094654780.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1768186914957/Frame%202094654887.jpg',
    },
    au: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1786070110925-8qaef4-compressed-full-width-carousel.webp',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1786070376407-mzvxir-compressed-Frame%202094655039.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1786070394790-tkzobc-compressed-Frame%202094655040.webp',
    },
};

function TheComp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();
    const images = F_IMAGE_MAP[locale] || F_IMAGE_MAP.us;

    useCardsShowHook('.cost-saving-F', '.cost-saving-F');
    return (
        <>
            <section
                className={`${css.section} cost-saving-F GtmModuleData-section`}
                id="cost-saving-F"
                data-section-id={'cost-saving-F'}
                data-section-title={t('F_title')}
            >
                <EcoImg className="img" pc={images.pc} pad={images.pad} h5={images.h5} isOpenLazy />
                <div className="F-info">
                    <div className="F-title">{t('F_title')}</div>
                    <div className="F-subtitle">{t('F_subtitle')}</div>
                    <div className="F-desc">{t('F_desc')}</div>
                </div>
            </section>
        </>
    );
}

export default TheComp;
